import { useState } from 'react';

const useEditPublishPreferences = () => {
  const [isEditPublishPreferencesDrawerOpen, setIsEditPublishPreferencesDrawerOpen] = useState(false);

  const handleEditPublishPreferences = () => {
    setIsEditPublishPreferencesDrawerOpen(true);
  };

  const handleCloseEditPublishPreferencesDrawer = () => {
    setIsEditPublishPreferencesDrawerOpen(false);
  };
  return { isEditPublishPreferencesDrawerOpen, handleEditPublishPreferences, handleCloseEditPublishPreferencesDrawer };
};
export default useEditPublishPreferences;
